import { AwardItemProps } from 'components/award-carousel';

export enum Rankings {
  RealTrends = '/assets/images/exp-homepage/real_trends_logo.png',
  PowerBroker = '/assets/images/exp-homepage/power_broker_logo.png'
}

export const homeExpAwards: AwardItemProps[] = [ 
  {
    providerImage: '/assets/images/exp-homepage/glass_door_logo.png',
    text: 'Best Places to Work',
    providerImageWidth: 244,
    providerImageHeight: 73,
    textClassName: 'glass-door-award',
  },
  {
    providerImage: '/assets/images/exp-homepage/forbes_logo.png',
    text: 'America’s Best Large Employers',
    providerImageWidth: 198,
    providerImageHeight: 56,
    textClassName: 'forbes-award',
  },
  {
    providerImage: '/assets/images/exp-homepage/deloitte_award.png',
    providerImageWidth: 115,
    providerImageHeight: 95,
    awardClassName: 'row-award-deloitte',
  },
  {
    providerImage: Rankings.RealTrends,
    text: 'Best Brokerages',
    providerImageWidth: 115,
    providerImageHeight: 20,
    rank: 1,
  },
  {
    providerImage: Rankings.RealTrends,
    text: '5 Year Top Movers in Sides & Volume',
    providerImageWidth: 115,
    providerImageHeight: 20,
    rank: 1,
  },
  {
    providerImage: Rankings.RealTrends,
    text: 'Transactions',
    providerImageWidth: 115,
    providerImageHeight: 20,
    rank: 1,
  },
  {
    providerImage: Rankings.RealTrends,
    text: 'Public Independent',
    providerImageWidth: 115,
    providerImageHeight: 20,
    rank: 1,
  },
  {
    providerImage: Rankings.PowerBroker,
    text: 'Transactions',
    providerImageWidth: 115,
    providerImageHeight: 20,
    rank: 1,
  },
];

export const aboutZooAwards: AwardItemProps[] = [ 
  {
    providerImage: '/next/assets/images/about/award-startup.png',
    text: 'Fastest Growing Companies 2020 - Startup List',
    providerImageWidth: 56,
    providerImageHeight: 76,
    awardClassName: 'zoo-award',
  },
  {
    providerImage: '/next/assets/images/about/award-globe.png',
    text: "Canada's Top Growing Companies 2020",
    providerImageWidth: 160,
    providerImageHeight: 66,
    awardClassName: 'zoo-award',
  },
  {
    providerImage: '/next/assets/images/about/award-ft.png',
    text: "Americas' Fastest Growing Companies 2020",
    providerImageWidth: 86,
    providerImageHeight: 95,
    awardClassName: 'zoo-award',
  },
  {
    providerImage: '/next/assets/images/about/award-50.png',
    text: 'Fast 50 Companies 2019',
    providerImageWidth: 213,
    providerImageHeight: 50,
    awardClassName: 'zoo-award',
  },
];